import { rest } from 'msw'
import { MOCK_USER } from '../data/user'
import { config } from '@config/index'

export const handlers = [
  //whoelsale web
  rest.post(`${config.wholeSaleWebUser.url}`, (_req, _res, _ctx) => {
    return _res(_ctx.status(200), _ctx.json({ ...MOCK_USER }))
  }),
]
